import React from 'react'

import { SvgWrapper } from './SvgWrapper/SvgWrapper'

export const BankCardDefaultSvg = ({ size = 24 }: { size?: number }) => (
  <SvgWrapper size={size}>
    <path
      fill="#D7E0EE"
      fillRule="evenodd"
      d="M4.085 20.274l-3.437-4.56c-.743-.986-.544-2.388.437-3.128L15.092 2.031c.984-.741 2.382-.545 3.126.443l3.437 4.56-17.57 13.24zm4.823 2.695c-.984.741-2.382.545-3.126-.443l-.393-.521 17.57-13.24.393.521c.743.986.544 2.388-.437 3.128L8.908 22.969z"
    />
  </SvgWrapper>
)
